
export default {
    getWxUser: {
        method: 'post',
        url: '/cors/wxAuth/codeToUserInfo',
    },
    getWxUserOpenId: {
        method: 'post',
        url: '/cors/wxAuth/codeToOpenid',
    },
    wxUserLogin: {
        method: 'get',
        url: '/cors/wx/wxuser/relatedUser'
    },
    getShareSignature: {
        url: '/cors/wxAuth/getShareSignature',
        method: 'get'
    },
    getToken: {
        url: '/tjd-auth/oauth/token',
        method: 'post',
        param: true
    },
    getMobileBannerList: {
        url: '/base/mobilebanner/getBannerByType',
        method: 'get'
    }
}
